<script setup>
import { computed } from 'vue';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    label: {
        type: String,
        default: 'Exibir Todos',
    },
    // Texto exibido enquanto o botão está ligado, para indicar o estado atual da listagem
    labelAtivo: {
        type: String,
        default: 'Exibindo Todos',
    },
    tooltip: {
        type: String,
        default: null,
    },
    // Mantém a label sempre visível, sem depender do hover/foco para expandir
    labelFixo: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const labelAtual = computed(() => (props.modelValue ? props.labelAtivo : props.label));
</script>

<template>
    <BotaoFiltro :label="labelAtual" :tooltip="tooltip" :ativo="modelValue" :label-fixo="labelFixo"
        :icone-material="modelValue ? 'visibility' : 'visibility_off'"
        @click="emit('update:modelValue', !props.modelValue)" />
</template>
